import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { getCurrentUser } from '@/store/slices/authSlice'

/**
 * Global authentication initializer
 * Checks session on app startup to persist login across page refreshes
 * Uses useRef to prevent double-dispatch in React StrictMode (dev only)
 */
export default function AuthInitializer() {
  const dispatch = useAppDispatch()
  const { hasCheckedAuth } = useAppSelector((state) => state.auth)
  const initialized = useRef(false)

  useEffect(() => {
    // Only check auth once per app mount
    // useRef persists across effect re-invocations in React StrictMode
    if (!initialized.current) {
      initialized.current = true
      
      // Dispatch only if we haven't checked yet
      // This will check the httpOnly cookie for valid session
      if (!hasCheckedAuth) {
        dispatch(getCurrentUser()).catch(() => {
          // Silently handle errors - user is simply not authenticated
        })
      }
    }
  }, [dispatch, hasCheckedAuth])

  return null
}

